// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gUOn","select":"styles_select__3YoDV"};